import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { Button } from 'react-materialize';

import Logger from '../../functions/logging';

import '../../static/gdpr.css';
import { connect } from 'react-redux';
import * as actions from '../../redux/actions/index';
import * as localeFns from '../../functions/locale';

/* Google analytics */
import ActionStatus from '../../analytics/analytics-events/ActionStatus';
import { ActionStatusEvent } from '../../analytics/analytics-events/constants';
import DeviceHelper from '../../functions/device';

/*
"Read how we use cookies and how you can control them in our “Cookie Settings”."

Linkedin cookie policy page
https://www.linkedin.com/legal/cookie-policy?trk=guest_job_search_cookie_policy_click
*/
class GDPRPrompt extends Component {
	constructor(props) {
		super(props);
		this.state = {
			gdprAccepted: localeFns.getGDPRConsent()
		};
	}

	handleAcceptGDPR = () => {
		this.setState({
			gdprAccepted: true
		});
		localeFns.setGDPRConsent(true);

		let actionStatus = new ActionStatus(ActionStatusEvent.GDPR_CONSENT, '', '', false, false, true);
		actionStatus.gaTracker = this.props.tracker;
		this.props.globalAnalyticsAdapter.reportAnalyticsEvent(actionStatus);
	}

	render() {
		Logger.log(this.constructor.name, "render()", this.props, this.state);
		let { panelPartner } = this.props;
		let buttonClass = panelPartner ? 'default-btn' : '';
		const partnerWrapperClass = panelPartner;
		if (this.state.gdprAccepted) {
			return null;
		}

		return (
			<div className={`optanon-alert-box-wrapper ${DeviceHelper.isMobile ? "mobile" : ""} ${partnerWrapperClass}`} style={{"bottom": "0px"}}>
				{/* <div className="optanon-alert-box-bottom-top">
					<div className="optanon-alert-box-corner-close">
						<a className="optanon-alert-box-close" href="#" title="Close Banner" onClick="Optanon.TriggerGoogleAnalyticsEvent('OneTrust Cookie Consent', 'Banner Close Button');"></a>
					</div>
				</div> */}
				<div className="optanon-alert-box-bg">
					<div className="optanon-alert-box-logo"> </div>
					<div className="optanon-alert-box-body">
						<p>
							<FormattedMessage
								id="destination_prompt.gdpr_consent"
								defaultMessage={`We use cookies to offer you a better browsing experience, analyze site traffic, and personalize content. By using our site, you consent to our use of cookies.`}
							/>
						</p>
					</div>
					<div className="optanon-clearfix"></div>
					<div className="optanon-alert-box-button-container">
						{/* <div className="optanon-alert-box-button optanon-button-close">
							<div className="optanon-alert-box-button-middle">
								<a className="optanon-alert-box-close" href="#">Close</a>
							</div>
						</div> */}
						{/* <div className="optanon-alert-box-button optanon-button-allow">
							<div className="optanon-alert-box-button-middle">
								<a className="optanon-allow-all" href="#" onClick={() => this.handleAcceptGDPR()}>Accept Cookies</a>
							</div>
						</div> */}
						<Button type="button" waves='light' className={`waves-effect waves-light ${buttonClass}`} onClick={() => this.handleAcceptGDPR()}>
							<FormattedMessage
								id="destination_prompt.gdpr_consent.button"
								defaultMessage={`Accept Cookies`}
							/>
						</Button>
						{/* <div className="optanon-alert-box-button optanon-button-more">
							<div className="optanon-alert-box-button-middle"><a className="optanon-toggle-display" href="#" onClick="Optanon.TriggerGoogleAnalyticsEvent('OneTrust Cookie Consent', 'Banner Open Preferences');">Cookie Settings</a></div>
						</div> */}
					</div>
					{/* <div className="optanon-clearfix optanon-alert-box-bottom-padding"></div> */}
				</div>
			</div>
		);
	}
}

const mapStateToProps = state => ({
	panelPartner: state.targetProcess.panelPartner,
	tracker: state.GlobalAnalyticsAdapterReducer.gaTracker,
	globalAnalyticsAdapter: state.GlobalAnalyticsAdapterReducer.globalAnalyticsAdapter,
});

export default connect(mapStateToProps, actions)(GDPRPrompt);


// WEBPACK FOOTER //
// ./src/components/landing/GDPRConsent.js